import React, { ReactElement } from 'react'
import * as style from 'src/components/MaskedCardNumber/MaskedCardNumber.style'
import { useTranslate } from 'src/localization/Trns'

export interface MaskedCardNumberProps {
  lastFour: string
  /**
   * Optional CSS class so each consumer can apply its own typography
   * (tabular-nums, letter-spacing, weight, etc.) without forking the
   * accessibility orchestration below.
   */
  className?: string
}

/**
 * Renders a masked card number like `**** 1234` with the masking glyph
 * and digits hidden from assistive tech, paired with a visually-hidden
 * "ending in 1234" phrase so screen readers announce something
 * meaningful instead of "asterisk asterisk asterisk asterisk".
 *
 * Centralizes a triplet that previously lived inline in both the card
 * feed details table and the inner flyout table — keeps the mask glyph
 * and the localized SR phrase in lockstep across consumers.
 */
const MaskedCardNumber: React.FC<MaskedCardNumberProps> = ({
  lastFour,
  className,
}): ReactElement => {
  const translate = useTranslate()
  return (
    <span className={className}>
      <span aria-hidden="true">{'**** '}</span>
      <span css={style.visuallyHidden}>
        {translate('ending in ${lastFour}', { lastFour })}
      </span>
      <span aria-hidden="true">{lastFour}</span>
    </span>
  )
}

export default MaskedCardNumber
